import { createI18n } from 'vue-i18n'
import AppConfig from '~/config/appConfig.js'

import enMessages from '@/locales/messages/en.json'
import esMessages from '@/locales/messages/es.json'
import swMessages from '@/locales/messages/sw.json'

import enNumberFormats from '@/locales/numberFormats/en.json'
import esNumberFormats from '@/locales/numberFormats/es.json'
import swNumberFormats from '@/locales/numberFormats/sw.json'

export default createI18n({
  // Use a ! to force vue-i18n to not replace the locale with an alternative. E.g en -> en-US
  locale: `${AppConfig.defaultLocale}!`,
  fallbackLocale: `${AppConfig.defaultLocale}!`,
  availableLocales: ["en", "es", "sw"],
  globalInjection: false,
  legacy: false,
  messages: { ...enMessages, ...esMessages, ...swMessages },
  numberFormats: { ...enNumberFormats, ...esNumberFormats, ...swNumberFormats },
  missingWarn: true,
  fallbackWarn: false
})
